
  import { Component, Mixins } from "vue-property-decorator";
  import TheNavbar from "@/components/TheNavbar.vue";
  import TheFooter from "@/components/TheFooter.vue";
  import { ISearchBarViewModel } from "@/models";
  import { Numeric, WebAgent } from "@/helper";
  import TheBottomTab from "@/components/TheBottomTab.vue";
  import UpdateMixin from "./update-mixin";

  @Component({
    name: "App",
    mixins: [UpdateMixin],
    components: { TheBottomTab, TheFooter, TheNavbar }
  })
  export default class App extends Mixins(UpdateMixin) {
    installer: Function;
    searchParams: ISearchBarViewModel = {
      category: 0,
      state: 0,
      date: 0,
      searchText: ""
    };

    publicPath: string = process.env.BASE_URL as string;
    // set right image path
    getImagePath(path: string) {
      return `${this.publicPath}${path}`;
    }

    async created() {
     
      var installPrompt;
      window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault();
        installPrompt = e;
        // disable add to home screen button
        // this.$bvModal.show("modal-install");
      });

      this.installer = () => {
        this.$bvModal.hide("modal-install");
        installPrompt.prompt();
        installPrompt.userChoice().then(result => {
          if (result.outcome === "accepted") {
            console.log("User accepted");
          } else {
            console.log("User denied");
          }
          installPrompt = null;
        });
      };
      //  [App.vue specific] When App.vue is first loaded start the progress bar
      this.$Progress.start();
      //  hook the progress bar to start before we move router-view
      this.$router.beforeEach((to, from, next) => {
        //  does the page we want to go to have a meta.progress object
        if (to.meta.progress !== undefined) {
          var meta = to.meta.progress;
          // parse meta tags
          this.$Progress.parseMeta(meta);
        }
        //  finish the progress bar
        if (
          to.name !== null &&
          to.name !== undefined &&
          to.name.toLowerCase() === "pagesearch"
        ) {
          const { date, categoryId, stateId, searchText } = to.params;
          this.searchParams = {
            category: Numeric.ConvertToNumber(categoryId, 0),
            date: Numeric.ConvertToNumber(date, 0),
            state: Numeric.ConvertToNumber(stateId, 0),
            searchText: searchText || ""
          };
        }
        //  start the progress bar
        this.$Progress.start();
        //  continue to next page
        next();
      });
      //  hook the progress bar to finish after we've finished moving router-view
      this.$router.afterEach(() => {
        this.$Progress.finish();
      });
    }

    get isShowNavigation() {
      var path = this.$route.path.toLowerCase();
      return !["/maintenance", "/login", "/authorize"].includes(path);
    }
    onSearchFormChange(form: ISearchBarViewModel) {
      this.searchParams = form;
    }
    get searchForm() {
      return Object.assign({}, this.searchParams);
    }

    get isMobileView() {
      return WebAgent.IsMobile();
    }
    get isBottomNavigationVisible() {
      if (WebAgent.IsMobile()) {
        return this.isShowNavigation;
      }
      return false;
    }
  }
